import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "./HtmlText";
import TallyIframe from "@/components/tally-forms/TallyIframe";

// --------------------------------------------------------------------------------------------

export type ITextWithEmbedSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  form?: string;
};

const TextWithEmbedSection: FC<ITextWithEmbedSectionProps> = (props) => {
  const { heading, description, form, className, ...other } = props;

  return (
    <section className={clsx("container mx-auto", className)} {...other}>
      <div className="flex flex-col gap-10 py-5 lg:flex-row lg:gap-12 lg:py-8 xl:gap-20 xl:py-[50px]">
        {(heading || description) && (
          <div className="w-full">
            {/* title */}
            {heading && (
              <h2 className="mb-4 w-full font-sans text-h5 font-medium text-black-900 lg:mb-7 lg:text-h3 xl:text-h2">
                {heading}
              </h2>
            )}

            {/* Description */}
            {description && <HtmlText>{description}</HtmlText>}
          </div>
        )}

        {/* form */}
        {form && (
          <div className="w-full bg-primary-100 p-6 !pb-3 lg:max-w-[550px] lg:p-8 lg:!pb-5 xl:p-12 xl:!pb-9">
            <TallyIframe
              url={form}
              className="mx-auto w-full font-sans lg:min-w-[400px] xl:min-w-[450px]"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default TextWithEmbedSection;
